/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceByDeviceTypeResponse,
    DeviceByDeviceTypeResponseFromJSON,
    DeviceByDeviceTypeResponseFromJSONTyped,
    DeviceByDeviceTypeResponseToJSON,
} from './DeviceByDeviceTypeResponse';

/**
 * 
 * @export
 * @interface DevicesByDeviceTypeResponse
 */
export interface DevicesByDeviceTypeResponse {
    /**
     * 
     * @type {Array<DeviceByDeviceTypeResponse>}
     * @memberof DevicesByDeviceTypeResponse
     */
    devices?: Array<DeviceByDeviceTypeResponse>;
    /**
     * 
     * @type {number}
     * @memberof DevicesByDeviceTypeResponse
     */
    count?: number;
}

export function DevicesByDeviceTypeResponseFromJSON(json: any): DevicesByDeviceTypeResponse {
    return DevicesByDeviceTypeResponseFromJSONTyped(json, false);
}

export function DevicesByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevicesByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'devices': !exists(json, 'devices') ? undefined : ((json['devices'] as Array<any>).map(DeviceByDeviceTypeResponseFromJSON)),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function DevicesByDeviceTypeResponseToJSON(value?: DevicesByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'devices': value.devices === undefined ? undefined : ((value.devices as Array<any>).map(DeviceByDeviceTypeResponseToJSON)),
        'count': value.count,
    };
}

